module.exports = __webpack_public_path__ + "img/app_new_main_2.68387fb8.jpg";